import React from 'react';
import { useOutletContext, useParams } from 'react-router-dom';
import { Alumni as SharedAlumni } from '@enrich/shared-lib';

export const Alumni = () => {
    const user = useOutletContext();
    const { schoolSlug } = useParams();

    return (
        <SharedAlumni
            schoolId={user.school.id}
            studentPathTemplate={`/${schoolSlug}/students/:id`}
        />
    );
};
